export enum ContractedFeaturesEnum {
    CHEGUEI = 'Cheguei',
    SEAT_BOOKINGS = 'SeatBookings',
    TICKETS = 'Tickets',
  }
  